(() => {
  const STORAGE_KEY = 'mkr_cookie_consent_v3';
  const STORAGE_TEST_KEY = 'mkr_cookie_storage_test';

  const canUseStorage = () => {
    try {
      window.localStorage.setItem(STORAGE_TEST_KEY, '1');
      window.localStorage.removeItem(STORAGE_TEST_KEY);
      return true;
    } catch (error) {
      return false;
    }
  };

  const initCookieConsent = () => {
    const banner = document.querySelector('[data-mkr-cookie]');

    if (!banner) return;

    const preferences = banner.querySelector('[data-mkr-cookie-preferences]');
    const toggle = banner.querySelector('[data-mkr-cookie-toggle]');
    const save = banner.querySelector('[data-mkr-cookie-save]');
    const accept = banner.querySelector('[data-mkr-cookie-accept]');
    const reject = banner.querySelector('[data-mkr-cookie-reject]');
    const inputs = Array.from(banner.querySelectorAll('[data-mkr-consent-input]'));
    const storageAvailable = canUseStorage();
    const forcePreview = new URLSearchParams(window.location.search).has('mkr_cookie_preview');

    const hasStoredConsent = () => {
      if (!storageAvailable) return false;

      try {
        return window.localStorage.getItem(STORAGE_KEY) !== null;
      } catch (error) {
        return false;
      }
    };

    const rememberConsent = (consent) => {
      if (!storageAvailable) return;

      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...consent, savedAt: new Date().toISOString() }));
      } catch (error) {
        // Consent still goes to Shopify when available; storage can fail in strict browser modes.
      }
    };

    const hideBanner = () => {
      banner.setAttribute('hidden', '');
    };

    const showBanner = () => {
      banner.removeAttribute('hidden');
    };

    const setInputState = (consent) => {
      inputs.forEach((input) => {
        const key = input.dataset.mkrConsentInput;
        input.checked = Boolean(consent[key]);
      });
    };

    const selectedConsent = () => {
      return inputs.reduce(
        (consent, input) => {
          consent[input.dataset.mkrConsentInput] = input.checked;
          return consent;
        },
        {
          analytics: false,
          marketing: false,
          preferences: false,
        }
      );
    };

    const applyConsent = (consent) => {
      const payload = {
        analytics: Boolean(consent.analytics),
        marketing: Boolean(consent.marketing),
        preferences: Boolean(consent.preferences),
        sale_of_data: false,
      };

      rememberConsent(payload);

      if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
        window.Shopify.customerPrivacy.setTrackingConsent(payload, hideBanner);
        return;
      }

      hideBanner();
    };

    const openPreferences = () => {
      preferences?.removeAttribute('hidden');
      save?.removeAttribute('hidden');
      toggle?.setAttribute('hidden', '');
    };

    if (!forcePreview && hasStoredConsent()) return;

    setInputState({ analytics: false, marketing: false, preferences: false });
    showBanner();

    toggle?.addEventListener('click', openPreferences);

    save?.addEventListener('click', () => {
      applyConsent(selectedConsent());
    });

    reject?.addEventListener('click', () => {
      applyConsent({ analytics: false, marketing: false, preferences: false });
    });

    accept?.addEventListener('click', () => {
      const consent = { analytics: true, marketing: true, preferences: true };
      setInputState(consent);
      applyConsent(consent);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCookieConsent, { once: true });
    return;
  }

  initCookieConsent();
})();
